import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/job/${':jobId' | number}/bulkRemove`;

export const ROUTE: RouteDefinition = `${baseRoute}/job/:jobId/bulkRemove`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/job/${jobId}/bulkRemove`;
